const colors = {
  black: '#0C0D0D',
  white: '#FFF',
  gray: '#3A3A3A',
  grayLight: '#AFB3B8',
  accent: '#7FFF43',
  accentSecondary: '#F50DBF',
};
export default colors;
